module.exports = __webpack_public_path__ + "static/media/r_2_7.de2c5c58.png";